import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  const appVersion = require('../../../package.json').version;
  return new TranslateHttpLoader(http, './assets/i18n/', `.json?_=${appVersion}`);
}
